/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SpecInputs */

const en_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const ar_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#مواصفات`)
};

const bn_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const de_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const es_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const fr_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const pt_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const zh_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const tr_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const ru_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

const pl_svtag_spec = /** @type {(inputs: Svtag_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPEC`)
};

/**
* | output |
* | --- |
* | "#SPEC" |
*
* @param {Svtag_SpecInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_spec = /** @type {((inputs?: Svtag_SpecInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SpecInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_spec(inputs)
	if (locale === "bn") return bn_svtag_spec(inputs)
	if (locale === "de") return de_svtag_spec(inputs)
	if (locale === "es") return es_svtag_spec(inputs)
	if (locale === "fr") return fr_svtag_spec(inputs)
	if (locale === "pt") return pt_svtag_spec(inputs)
	if (locale === "zh") return zh_svtag_spec(inputs)
	if (locale === "tr") return tr_svtag_spec(inputs)
	if (locale === "ru") return ru_svtag_spec(inputs)
	if (locale === "pl") return pl_svtag_spec(inputs)
	return en_svtag_spec(inputs)
});